import React, { createContext, useContext, useRef, useState } from 'react';
import { useInstallerPrerequisites } from '../hooks/useInstallerPrerequisites';
import { setIsBulkInstallTriggered } from '../selectors/bulk-installer-triggered';
import { isLegacyInstallerFlow } from '../services/is-legacy-installer-flow';
export const initialInstallerRenderControlContextValues = {
  retryInstallation: () => {},
  setInstallerUiReady: () => {},
  isLoadingInstaller: true,
  prerequisitesState: {
    isDetermined: false
  },
  shouldUseOldInstaller: false
};
export const InstallerRenderControlContext = /*#__PURE__*/createContext(initialInstallerRenderControlContextValues);
export const InstallerRenderControlProvider = _ref => {
  let {
    children,
    essentials,
    panoramaClient,
    appId,
    topology,
    onUiInitialLoad,
    retryInstallationCount,
    setRetryInstallationCount,
    messagesPromise,
    errorOnLoginRedirect
  } = _ref;
  const {
    prerequisitesState
  } = useInstallerPrerequisites({
    essentials,
    panoramaClient,
    appId,
    topology,
    messagesPromise,
    errorOnLoginRedirect
  });
  const [isInstallerUiAnnouncedReady, setInstallerUiAnnouncedReady] = useState(false);
  const installerUiReadyRef = useRef(false);
  const retryInstallation = () => {
    setIsBulkInstallTriggered(false);
    setRetryInstallationCount(prev => prev + 1);
  };
  const setInstallerUiReady = () => {
    if (!installerUiReadyRef.current) {
      retryInstallationCount === 0 && (onUiInitialLoad == null ? void 0 : onUiInitialLoad());
      setInstallerUiAnnouncedReady(true);
      installerUiReadyRef.current = true;
    }
  };
  const isLoadingInstaller = !isInstallerUiAnnouncedReady || !prerequisitesState.isDetermined;
  return /*#__PURE__*/React.createElement(InstallerRenderControlContext.Provider, {
    value: {
      prerequisitesState,
      isLoadingInstaller,
      retryInstallation,
      setInstallerUiReady,
      shouldUseOldInstaller: prerequisitesState.isDetermined && isLegacyInstallerFlow(appId)
    }
  }, children);
};
export const useRenderControl = () => useContext(InstallerRenderControlContext);
//# sourceMappingURL=InstallerRenderControlContext.js.map